require('../theme/fonts/feather/feather.min.css');
require('../theme/fonts/icomoon/icomoon.css');
require('../theme/css/theme.min.css');
require('../css/app.css');
const routes = require('../../public/js/fos_js_routes.json');
Routing.setRoutingData(routes);

import { createApp } from 'vue';
import * as Sentry from '@sentry/vue';
import BootstrapNative from 'bootstrap.native/dist/bootstrap-native-v4';
import Routing from '../../assets/js/dependencies/jsrouting-bundle/router.min.js';
import Cookies from 'js-cookie';
import moment from 'moment';
import 'moment/locale/en-gb'
import 'moment/locale/vi'
import 'moment/locale/ko'

// import components
import Cinemas from './components/Cinemas';
import CinemaSessions from './components/CinemaSessions';
import PostTags from './components/PostTags';
import MovieReviews from './components/MovieReviews';
import SectionPosts from './components/SectionPosts';
import SectionReviews from './components/SectionReviews';
import Regions from './components/Regions';
import Booking from './components/Booking';
import Voucher from './components/Voucher.vue';

// create Vue app
const app = createApp({});

// create root object
const root = {
  url: function(routeName, params) {
    return Routing.generate(routeName, params);
  },
  asset: function(path) {
    let baseUri = process.env.APP_CDN_URL;
    return baseUri + '/' + path;
  },
  loading: function() {
    return true;
  },
  moment: function(...args) {
    return moment(...args).locale('vi');
  },
  getRegion: function() {
    let currentRegion = Cookies.get('region');
    if (typeof currentRegion === "undefined" || currentRegion === "null") {
      currentRegion = 1; // hcmc
    } else {
      currentRegion = parseInt(currentRegion);
    }
    return currentRegion;
  },
  setRegion: function(region) {
    Cookies.set('region', region, { expires: 365 });
  },
  getCookie: function() {
    return Cookies;
  }
};

// provide root object
app.provide('root', root);

// register components
app.component('cinemas', Cinemas);
app.component('cinema-sessions', CinemaSessions);
app.component('post-tags', PostTags);
app.component('movie-reviews', MovieReviews);
app.component('section-posts', SectionPosts);
app.component('section-reviews', SectionReviews);
app.component('regions', Regions);

// booking components
app.component('booking', Booking);

// voucher components
app.component('voucher', Voucher);

// setup sentry
Sentry.init({
  app,
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENVIRONMENT,
  sendDefaultPii: true,
  integrations: [
  ],
});

// mount app
app.mount('#app');

const initialize = () => {
  // modals
  const modals = document.querySelectorAll(`[data-toggle="modal"]`);
  Array.from(modals).forEach(modal => {
    new BootstrapNative.Modal(modal);
  });

  // dropdowns
  const dropdowns = document.querySelectorAll(`[data-toggle="dropdown"]`);
  Array.from(dropdowns).forEach(dropdown => {
    new BootstrapNative.Dropdown(dropdown, true);
  });

  // popovers
  const popovers = document.querySelectorAll(`[data-toggle="popover"]`);
  Array.from(popovers).forEach(popover => {
    new BootstrapNative.Popover(popover);
  });

  // collapses
  const collapses = document.querySelectorAll(`[data-toggle="collapse"]`);
  Array.from(collapses).forEach(collapse => {
    new BootstrapNative.Collapse(collapse);
  });
};

initialize()
